import { render } from "./CardReg.vue?vue&type=template&id=358323f5"
import script from "./CardReg.vue?vue&type=script&lang=js"
export * from "./CardReg.vue?vue&type=script&lang=js"
script.render = render

export default script